import {createAction} from "@reduxjs/toolkit";

export const pushArchiveEvents = createAction('PUSH_ARCHIVE_EVENTS');